<template>
  <div class="resource" v-if="userEqui == 'pc'">
    <div class="allShrink">
      <div class="header-banner">
        <!-- <div class="login-area" v-if="!showLogin">
          <login-area></login-area>
        </div> -->
        <!-- <div class="swiper">
          <el-carousel
            class="carousel"
            :interval="4000"
            :loop="true"
            arrow="always"
            height="500px"
          >
            <el-carousel-item>
              <p class="slogan">沉睡资产变增收活水</p>
              <img src="../../assets/imgs/banner3.png" alt="" />
            </el-carousel-item>
            <el-carousel-item>
              <p class="slogan">闲置资源变产业活水</p>
              <img src="../../assets/imgs/banner3-1.png" alt="" />
            </el-carousel-item>
            <el-carousel-item>
              <p class="slogan three">资源资产引入金融活水</p>
              <img src="../../assets/imgs/banner3-2.png" alt="" />
            </el-carousel-item>
          </el-carousel>
        </div> -->
      </div>

      <!-- 快速入口 -->
      <!-- <r-quick-link></r-quick-link> -->

      <!-- 竞价大厅 -->
      <resource-hall routerName="resourcesService"></resource-hall>

      <!-- 成果展示 -->
      <achieve-display></achieve-display>

      <!-- 交易流转动态 -->
      <!-- <production-performance></production-performance> -->

      <!-- 交易流转统计 -->
      <landtrust-statistics></landtrust-statistics>
    </div>
  </div>
  <div class="resource-web" v-else>
    <div class="allShrink-web">
      <div class="header-banner-web">
        <div class="login-area" v-if="!showLogin">
          <login-area></login-area>
        </div>
      </div>

      <!-- 快速入口 -->
      <!-- <r-quick-link></r-quick-link> -->

      <!-- 竞价大厅 -->
      <resource-hall routerName="resourcesService"></resource-hall>

      <!-- 成果展示 -->
      <achieve-display></achieve-display>

      <!-- 交易流转动态 -->
      <!-- <production-performance></production-performance> -->

      <!-- 交易流转统计 -->
      <landtrust-statistics></landtrust-statistics>
    </div>
  </div>
</template>

<script>
import { getStore } from "@/js/utils/store";
import LoginArea from "@/components/LoginArea";
import RQuickLink from "./components/RQuickLink.vue";
import ResourceHall from "../homepage/components/ResourceHall.vue";
import AchieveDisplay from "./components/AchieveDisplay.vue";
import ProductionPerformance from "./components/ProductionPerformance.vue";
import LandtrustStatistics from "./components/LandtrustStatistics.vue";
import BaiDuMap from "@/views/resourcesService/components/baiduMap.vue";
export default {
  metaInfo: {
    title: window.pageConfiguration.company.title,
    meta: [
      {
        name: "description",
        content: window.pageConfiguration.company.description,
      },
      { name: "keywords", content: window.pageConfiguration.company.keywords2 },
    ],
  },
  components: {
    LoginArea,
    RQuickLink,
    ResourceHall,
    AchieveDisplay,
    ProductionPerformance,
    LandtrustStatistics,
    BaiDuMap,
  },

  data() {
    return {
      showLogin: getStore({ name: "access_token" }),
      userEqui: sessionStorage.getItem("equiType"),
    };
  },
  created() {
    console.log("进入resourcesService页面");
    console.log("查看用户设备", sessionStorage.getItem("equiType"));
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.resource {
  background: #fff;
  text-align: left;
  display: grid;
  .allShrink {
    width: 90%;
    margin: auto;
  }
}
.resource-web {
  background: #fff;
  // text-align: left;
  // display: grid;
  .allShrink-web {
    .header-banner-web {
      .swiper-web {
        width: 100%;
        // height: 500px;
        text-align: center;
        background: #fff;
        // position: relative;
        .carousel-web {
          height: 150px;
          width: 100%;
          .swiper-item-web {
            position: relative;
            .slogan-web {
              position: absolute;
              color: #fff;
              font-size: 18px;
              left: 40px;
              top: 30px;
              z-index: 999;
            }
            .item-img-web {
              // position:absolute;
              width: 100%;
              height: 150px;
            }
          }
        }
      }
    }
  }
}
</style>
